export enum SortDirections {
    Ascending = 'ascending',
    Descending = 'descending',
}

export type SortColumn<SortColumnName extends string = string> = {
    columnName: SortColumnName;
    direction: SortDirections;
};

export function getSortOrder(columnName: string, sortColumns?: SortColumn[]) {
    if (sortColumns === undefined) {
        return undefined;
    }
    const column = sortColumns.find((i) => i.columnName === columnName);
    if (!column) {
        return undefined;
    }
    return column.direction;
}

export function updateSortColumns<SortColumnName extends string = string>(
    columnName: SortColumnName,
    newDirection: SortDirections | undefined,
    sortColumns?: SortColumn<SortColumnName>[],
): SortColumn<SortColumnName>[] {
    if (sortColumns === undefined) {
        if (newDirection === undefined) {
            return [];
        }
        return [{ columnName, direction: newDirection }];
    }
    const sortColumnsWithoutCurrentColumn = sortColumns.filter((i) => i.columnName !== columnName);
    if (newDirection === undefined) {
        return sortColumnsWithoutCurrentColumn;
    }

    return [{ columnName, direction: newDirection }, ...sortColumnsWithoutCurrentColumn];
}
